export default {"src":"/_next/static/media/central-african-republic.12bc778a.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};